'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

require('./Slider.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    SliderView: {
        displayName: 'SliderView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Slider/default/SliderView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var SliderView = _wrapComponent('SliderView')(function (_Component) {
    (0, _inherits3.default)(SliderView, _Component);

    function SliderView() {
        (0, _classCallCheck3.default)(this, SliderView);
        return (0, _possibleConstructorReturn3.default)(this, (SliderView.__proto__ || (0, _getPrototypeOf2.default)(SliderView)).apply(this, arguments));
    }

    (0, _createClass3.default)(SliderView, [{
        key: 'renderNav',
        value: function renderNav() {
            var _props = this.props,
                children = _props.children,
                lastIndex = _props.lastIndex,
                goToSlide = _props.goToSlide;


            var nav = children.map(function (slide, i) {
                var buttonClasses = i === lastIndex ? 'Slider-navButton Slider-navButton--active' : 'Slider-navButton';
                return _react3.default.createElement('button', {
                    className: buttonClasses,
                    key: i,
                    onClick: function onClick(event) {
                        return goToSlide(i, event);
                    } });
            });

            return _react3.default.createElement(
                'div',
                { className: 'Slider-nav' },
                nav
            );
        }
    }, {
        key: 'renderArrows',
        value: function renderArrows() {
            var _props2 = this.props,
                children = _props2.children,
                loop = _props2.loop,
                showNav = _props2.showNav,
                lastIndex = _props2.lastIndex,
                goToSlide = _props2.goToSlide;


            var arrowsClasses = showNav ? 'Slider-arrows' : 'Slider-arrows Slider-arrows--noNav';

            return _react3.default.createElement(
                'div',
                { className: arrowsClasses },
                loop || lastIndex > 0 ? _react3.default.createElement('button', {
                    className: 'Slider-arrow Slider-arrow--left',
                    onClick: function onClick(event) {
                        return goToSlide(lastIndex - 1, event);
                    } }) : null,
                loop || lastIndex < children.length - 1 ? _react3.default.createElement('button', {
                    className: 'Slider-arrow Slider-arrow--right',
                    onClick: function onClick(event) {
                        return goToSlide(lastIndex + 1, event);
                    } }) : null
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props3 = this.props,
                children = _props3.children,
                showArrows = _props3.showArrows,
                showNav = _props3.showNav,
                transition = _props3.transition,
                index = _props3.index;


            var slidesStyles = {
                width: 100 * children.length + '%',
                transform: 'translateX(' + -1 * index * (100 / children.length) + '%)'
            };
            var slidesClasses = transition ? 'Slider-slides Slider-slides--transition' : 'Slider-slides';

            return _react3.default.createElement(
                'div',
                { className: 'Slider', ref: 'slider' },
                showArrows ? this.renderArrows() : null,
                showNav ? this.renderNav() : null,
                _react3.default.createElement(
                    'div',
                    {
                        className: 'Slider-inner',
                        onTouchStart: function onTouchStart(event) {
                            return _this2.props.handleDragStart(event, true);
                        },
                        onTouchMove: function onTouchMove(event) {
                            return _this2.props.handleDragMove(event, true);
                        },
                        onTouchEnd: function onTouchEnd() {
                            return _this2.props.handleDragEnd(true);
                        } },
                    _react3.default.createElement(
                        'div',
                        {
                            className: slidesClasses,
                            style: slidesStyles },
                        children
                    )
                )
            );
        }
    }]);
    return SliderView;
}(_react2.Component));

exports.default = SliderView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Slider/default/SliderView.jsx
// module id = 1767
// module chunks = 0